function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter-2"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  type: "matrix",
  values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Row-Menu",
  transform: "translate(-248.000000, -500.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Video-+-Text",
  transform: "translate(248.000000, 500.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  stroke: "#CDD4DA",
  x: 0.5,
  y: 0.5,
  width: 159,
  height: 107
}), /*#__PURE__*/React.createElement("g", {
  id: "Group-11",
  transform: "translate(82.000000, 6.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#EBEDF0",
  x: 0,
  y: 0,
  width: 72,
  height: 96
}), /*#__PURE__*/React.createElement("g", {
  id: "Icon/Text/M/Default",
  transform: "translate(24.000000, 36.000000)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#000000",
  fillRule: "nonzero",
  opacity: 0,
  x: 0,
  y: 0,
  width: 24,
  height: 24
}), /*#__PURE__*/React.createElement("path", {
  d: "M20,4 L4,4 C3.44771525,4 3,4.44771525 3,5 L3,8 C3,8.55228475 3.44771525,9 4,9 C4.55228475,9 5,8.55228475 5,8 L5,6 L11,6 L11,19 L9,19 C8.44771525,19 8,19.4477153 8,20 C8,20.5522847 8.44771525,21 9,21 L15,21 C15.5522847,21 16,20.5522847 16,20 C16,19.4477153 15.5522847,19 15,19 L13,19 L13,6 L19,6 L19,8 C19,8.55228475 19.4477153,9 20,9 C20.5522847,9 21,8.55228475 21,8 L21,5 C21,4.44771525 20.5522847,4 20,4 Z",
  id: "Path",
  fill: "#000000",
  fillRule: "nonzero"
}))), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  stroke: "#8C9BA8",
  x: 0.5,
  y: 0.5,
  width: 71,
  height: 95
})), /*#__PURE__*/React.createElement("g", {
  id: "Group-12",
  transform: "translate(6.000000, 6.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#8C9BA8",
  x: 0,
  y: 0,
  width: 72,
  height: 96
}), /*#__PURE__*/React.createElement("g", {
  id: "Icon/Play/M/White-Default",
  transform: "translate(24.000000, 36.000000)",
  filter: "url(#filter-2)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#000000",
  fillRule: "nonzero",
  opacity: 0,
  x: 0,
  y: 0,
  width: 24,
  height: 24
}), /*#__PURE__*/React.createElement("path", {
  d: "M12,2 C6.4771525,2 2,6.4771525 2,12 C2,17.5228475 6.4771525,22 12,22 C17.5228475,22 22,17.5228475 22,12 C22,9.3478351 20.9464316,6.80429597 19.0710678,4.92893219 C17.195704,3.0535684 14.6521649,2 12,2 Z M12,20 C7.581722,20 4,16.418278 4,12 C4,7.581722 7.581722,4 12,4 C16.418278,4 20,7.581722 20,12 C20,14.1217319 19.1571453,16.1565632 17.6568542,17.6568542 C16.1565632,19.1571453 14.1217319,20 12,20 Z",
  id: "Shape",
  fill: "#000000",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.34,7.45 C11.8391189,6.98841249 11.1110814,6.87035235 10.49,7.15 C9.88669336,7.394048 9.49131828,7.97920312 9.49,8.63 L9.49,15.37 C9.49131828,16.0207969 9.88669336,16.605952 10.49,16.85 C10.7067765,16.9483165 10.9419708,16.9994457 11.18,17 C11.6089139,16.9980997 12.0220132,16.8378457 12.34,16.55 L16,13.18 C16.3309718,12.8769209 16.5194446,12.4487753 16.5194446,12 C16.5194446,11.5512247 16.3309718,11.1230791 16,10.82 L12.34,7.45 Z M11.5,14.6 L11.5,9.4 L14.31,12 L11.5,14.6 Z",
  id: "Shape",
  fill: "#000000",
  fillRule: "nonzero"
})))))));

function SvgIconVideoTxt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "160px",
    height: "108px",
    viewBox: "0 0 160 108",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Video + Text") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVideoTxt);
export default __webpack_public_path__ + "static/media/icon_video_txt.cf8632ff.svg";
export { ForwardRef as ReactComponent };